import * as React from 'react';
import { readCookie, writeCookie } from '@common/cookies';
import { apiService } from '@services/ApiService';
import { config } from '@common/config';

export class Version extends React.Component<{}, { [key: string]: string }> {
  constructor(props: {}) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    this.setState({
      App: config.version || '',
      Api: await apiService.getVersion()
    });
  }

  renderServiceVersions() {
    const rows = [];
    for (let key of Object.keys(this.state)) {
      const version = this.state[key];
      const cookieKey = `version-${key}`;
      const oldVersion = readCookie(cookieKey);
      rows.push(
        <tr key={key}>
          <td>{key}</td>
          <td style={version !== oldVersion ? { color: 'red' } : {}}>{version}</td>
        </tr>
      );
      writeCookie(cookieKey, version, 90);
    }
    return rows;
  }

  render() {
    return (
      <div>
        <h1>Versions</h1>
        <table>
          <thead>
            <tr>
              <th>Service</th>
              <th>Version</th>
            </tr>
          </thead>
          <tbody>{this.renderServiceVersions()}</tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/version/_components/version.component.tsx